const  modal_pop = document.querySelectorAll('.custom-modal-section');

/* Active modal */
document.addEventListener('modal:open', (event) => {
  modal_pop.forEach((modal) => modal.classList.add('active'));
});
/* close modal */
const closePopup = document.querySelector('.custom-modal-section-close');
closePopup.addEventListener('click', () => {
  modal_pop.forEach((modal) => modal.classList.remove('active'));
});

document.addEventListener('click', (e) => {
  if(e.target.matches('.custom-modal-section.active')) {
    modal_pop.forEach((modal) => modal.classList.remove('active'));
  }
})
